export default "__VITE_ASSET__DM0XeIg0__"